import React from 'react'
import commaSeparetedValue from '../../../../../../helpers/commaSeparetedValue'
import { StyledDetailsText, StyledTitle } from './DetailsWmo.css'
import ProductNotes from '@usap/carparts/src/shared/components/ProductNotes'

const detailsTextStyle = { marginBottom: '4px' }

const DetailsWmo = ({
  brand, productUrl, onClick, title, sku, price, productNotes,
}) => (
  <>
    <a href={productUrl} onClick={onClick}>
      <StyledTitle>
        <b>
          {brand?.toUpperCase()}
        </b>
        {' - '}
        {title}
      </StyledTitle>
    </a>
    <StyledDetailsText style={detailsTextStyle}>
      {`Part Number: ${sku}`}
    </StyledDetailsText>
    <StyledDetailsText>
      Unit Price: $
      {commaSeparetedValue(price)}
    </StyledDetailsText>
    <ProductNotes notes={productNotes} />
  </>
)

export default DetailsWmo
